import { render } from "./UploadComponent.vue?vue&type=template&id=0caed76e&scoped=true&ts=true"
import script from "./UploadComponent.vue?vue&type=script&lang=ts"
export * from "./UploadComponent.vue?vue&type=script&lang=ts"

import "./UploadComponent.vue?vue&type=style&index=0&id=0caed76e&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0caed76e"]])

export default __exports__